import React from 'react'

import {Box, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

import {ResponsiveContainer} from '@progyny/components/ResponsiveContainer'

type ComponentsContainerProps = {
  children: React.ReactNode
}

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    overflow: 'auto',
  },
}))

const ComponentsContainer = ({children}: ComponentsContainerProps) => {
  const {classes} = useStyles()

  return (
    <Box className={classes.root}>
      <ResponsiveContainer>{children}</ResponsiveContainer>
    </Box>
  )
}

export function withContainer(Component: any) {
  return function (props: any) {
    return (
      <ComponentsContainer>
        <Component {...props} />
      </ComponentsContainer>
    )
  }
}

export default ComponentsContainer
